import {SET_AUTH, SET_ERROR, SET_LOADING} from "./mutation_types";
import {storeUserData} from "../../data/AuthTokenStorage";


export default {
    [SET_ERROR](state, errors) {
        state.error = true;
        state.errorsList=errors;
    },

    [SET_LOADING](state, loading) {
        state.loading = loading;
    },

    [SET_AUTH](state, token) {
       storeUserData(token);
    },
}